import { useEffect, useState } from 'react'

import { SecondaryBase } from '../Commons/SecondaryBase'
import { ResetCurrentDynamic as BLResetCurrentDynamic, StartBallonsGame as BLStartBallonsGame, RestartBallonsGame as BLRestartBallonsGame, GetBalloonStats as BLGetBalloonStats } from '../../../utilities/BL/Zones'
import { MESSAGE_TYPE, useFloatMessage } from './../../Providers/FloatMessage'


// =========================================================================
// MAPPING VISUAL: Traducción de slugs internos a nombres amigables
// =========================================================================
const getVisualZoneName = (realZoneName) => {
    if (!realZoneName) return '';
    const normalized = realZoneName.toLowerCase().trim();
    const aliases = {
        'zona1': 'Juanjolote Local',
        'zona2': 'Juanjolote Visita'
    };
    return aliases[normalized] || realZoneName;
};


const Balloons = ({ getOutOfTheDynamic }) => {
    const { showMessage } = useFloatMessage();
    const status = {
        WAITING: 'WAITING',
        RUNNING: 'RUNNING',
        FINISHED: 'FINISHED'
    }

    const [isWorking, setIsWorking] = useState(false)
    const [phase, setPhase] = useState(status.WAITING)
    const [error, setError] = useState('')

    // Config (con defaults razonables)
    // const [points,setPoints] = useState(10)
    // const [time,setTime] = useState(30)
    // Config (con defaults razonables)
    const [points, setPoints] = useState(() => +localStorage.getItem('adm.balloons.points') || 10); // targetTapsPerBalloon
    const [time, setTime] = useState(() => +localStorage.getItem('adm.balloons.time') || 45);        // durationSeconds
    const [threshold, setThreshold] = useState(() => +localStorage.getItem('adm.balloons.threshold') || 10); // sendBatchThreshold
    const [timeoutMs, setTimeoutMs] = useState(() => {
        const v = localStorage.getItem('adm.balloons.timeoutMs');
        return v === null ? 0 : +v; // 0 = desactivado
    }); // sendBatchTimeoutMs
    const countdownSeconds = 3; // fijo por ahora (si quieres lo parametrizamos luego)

    const [matchId,setMatchId] = useState(null)
    
    // Estadísticas en vivo
    const [peak,setPeak] = useState(0)
    const [participantsByZone,setParticipantsByZone] = useState({})
    const [resultsByZone,setResultsByZone] = useState([])
    const [winners,setWinners] = useState([])
    const [winnerType,setWinnerType] = useState("none")

    // Persistencia local simple
    useEffect(() => { localStorage.setItem('adm.balloons.points', String(points)); }, [points])
    useEffect(() => { localStorage.setItem('adm.balloons.time', String(time)); }, [time])
    useEffect(() => { localStorage.setItem('adm.balloons.threshold', String(threshold)); }, [threshold])
    useEffect(() => { localStorage.setItem('adm.balloons.timeoutMs', String(timeoutMs)); }, [timeoutMs])

    const clampInt = (v, min, max) => Math.min(max, Math.max(min, (Number.isFinite(v) ? Math.trunc(v) : min)))


    const ReturnToDashboard = async () => {
        try {
            await BLResetCurrentDynamic()
            getOutOfTheDynamic()
        } catch (error) {
        
        }
    }

    const StartGame = async () => {
        try {
            setError('')
            setIsWorking(true)
            
            const payload = {
                targetTapsPerBalloon: clampInt(points, 1, 1000),
                durationSeconds:      clampInt(time, 5, 600),
                countdownSeconds:     clampInt(countdownSeconds, 1, 10),
                sendBatchThreshold:   clampInt(threshold, 1, 100),
                sendBatchTimeoutMs:   clampInt(timeoutMs || 0, 0, 5000) // 0 = desactivado
            }

            //const response = await BLStartBallonsGame(points, time, 3)
            // Opción B (si tu BL sigue posicional): BLStartBallonsGame(points, time, countdownSeconds, threshold, timeoutMs)
            const response = await BLStartBallonsGame(
              payload.targetTapsPerBalloon,
              payload.durationSeconds,
              payload.countdownSeconds,
              payload.sendBatchThreshold,
              payload.sendBatchTimeoutMs
            )
            
            if (response.success) {
                setMatchId(response.data.matchId)
                setPhase(status.RUNNING)
                // Limpia métricas previas
                setPeak(0)
                setParticipantsByZone({})
                setResultsByZone([])
                setWinners([])
                setWinnerType("none")
            } else {
                console.log(response.message)
                setError(response.message)
            }
        } catch (error) {
            console.log('StartGame: ' + error)
            setError(error)
        } finally {
            setIsWorking(false)
        }
    }

    const ResetGame = async () => {
        try {
            setError('')
            setIsWorking(true)
            
            const response = await BLRestartBallonsGame()
            
            if (response.success) {
                setPhase(status.WAITING)
                setMatchId(null)
                setPeak(0)
                setParticipantsByZone({})
                setResultsByZone([])
                setWinners([])
                setWinnerType("none")
            } else {
                console.log(response.message)
                setError(response.message)
            }
        } catch (error) {
            console.log('RestartGame: ' + error)
            setError(error)
        } finally {
            setIsWorking(false)
        }
    }

    // Polling de stats cuando está corriendo o en “transición”
    useEffect(() => {
        let timer

        const tick = async () => {
            const response = await BLGetBalloonStats()
            
            if (!response?.success) return
            
            const { phase: serverPhase, stats } = response.data || {}

            // serverPhase podría venir como "RUNNING"/"FINISHED"/"WAITING" (ajusta si lo mapeas distinto)
            if (serverPhase) setPhase(serverPhase)

            if (stats) {
                setPeak(stats.peakParticipantsTotal || 0)
                setParticipantsByZone(stats.currentParticipantsByZone || {})
                setResultsByZone(stats.resultsByZone || [])
                setWinnerType(stats.winnerType || "none")
                setWinners(stats.winners || [])
            }
        }

        // Haz polling en RUNNING y también en FINISHED un par de veces si quieres refrescar winners
        if (phase === status.RUNNING || phase === status.FINISHED) {
            tick() // dispara inmediato
            timer = setInterval(tick, 1500)
        }

        //return () => timer && clearInterval(timer)
         return () => { if (timer) clearInterval(timer); };
    }, [phase])


    // Inputs: handlers con clamp (evita NaNs y fuera de rango)
    const onPoints = (e) => setPoints(clampInt(+e.target.value || 0, 1, 1000))
    const onTime = (e) => setTime(clampInt(+e.target.value || 0, 1, 600))
    const onThreshold = (e) => setThreshold(clampInt(+e.target.value || 0, 1, 100))
    const onTimeoutMs = (e) => setTimeoutMs(clampInt(+e.target.value || 0, 0, 5000))


    return (
        <SecondaryBase actionToExecute={ReturnToDashboard}>
            <section className='AdmRunToGoal__Settings'>
                <p className='AdmRunToGoal__Title'><i className="bi bi-balloon"></i> Juego de globos</p>

                <div className='AdmRunToGoal__Settings__Controls'>
                    <div className='AdmRunToGoal__Text--Center'>
                        <p>
                            Estatus:
                            {phase && (
                                phase === status.WAITING ? (
                                    <>
                                        <i className="bi bi-hourglass-split"></i> Esperando a que comience el juego
                                    </>
                                ) : phase === status.RUNNING ? (
                                    <>
                                        <i className="bi bi-play-circle"></i> Juego en proceso
                                    </>
                                ) : phase === status.FINISHED && (
                                    <>
                                        <i className="bi bi-stop-circle"></i> Juego finalizado
                                    </>
                                )
                            )}
                        </p>
                    </div>

                    {/* Panel de estadísticas (simple y claro) */}
                    {(phase === status.RUNNING || phase === status.FINISHED) && (
                        <div className='AdmRunToGoal__Stats AdmRunToGoal__SpaceUp'>
                            <p>Estadísticas</p>
                            <p>Pico total de participantes: {peak}</p>

                            <p>Participantes actuales por zona</p>
                            <ul>
                                {Object.entries(participantsByZone).map(([zone, count]) => (
                                    <li key={zone}>{getVisualZoneName(zone)}: {count}</li>
                                ))}
                            </ul>

                            <p>Globos completados por zona</p>
                            <ul>
                                {resultsByZone.map(r => (
                                    <li key={r.zone}>
                                        {getVisualZoneName(r.zone)}: {r.completedBalloons} globos (taps {r.totalTaps})
                                    </li>
                                ))}
                            </ul>

                            {winnerType !== "none" && (
                                <>
                                    <p>Ganador(es)</p>
                                    <p>Tipo: {winnerType === 'single' ? '1 ganador' : winnerType === 'all-tie' ? 'Empate' : winnerType}</p>
                                    {/* <p>{winners.join(", ")}</p> */}
                                    <p>{winners.map(w => getVisualZoneName(w)).join(", ")}</p>
                                </>
                            )}
                        </div>
                    )}

                    <label className='AdmRunToGoal__Settings__Controls__Labels AdmRunToGoal__SpaceUp'>Cantidad de puntos para inflar un globo:</label>
                    {/* <input className='AdmRunToGoal__Settings__Controls__Inputs' type='number' min={1} value={points} onChange={e => setPoints(+e.target.value || 1)} /> disabled={phase !== phase.WAITING} */}
                    <input className='AdmRunToGoal__Settings__Controls__Inputs' type='number' min={1} value={points} onChange={onPoints} /> {/*disabled={phase !== phase.WAITING}*/}
                    <small className="AdmRunToGoal__Help text-small">Recomendado: 10 ptos.</small>

                    <label className='AdmRunToGoal__Settings__Controls__Labels'>Duración de la dinámica (segundos):</label>
                    <input className='AdmRunToGoal__Settings__Controls__Inputs' type='number' min={1} value={time} onChange={onTime} /> {/*disabled={phase !== phase.WAITING}*/}
                    <small className="AdmRunToGoal__Help text-small">Recomendado: 20 - 30 seg.</small>

                    <label className='AdmRunToGoal__Settings__Controls__Labels'>Cantidad de taps para enviar al servidor:</label>
                    <input className='AdmRunToGoal__Settings__Controls__Inputs' type='number' min={1} value={threshold} onChange={onThreshold} />
                    <small className="AdmRunToGoal__Help">Recomendado: 10 taps</small>

                    <label className='AdmRunToGoal__Settings__Controls__Labels'>Milisegundos para enviar taps al servidor (OPCIONAL)</label>
                    <input className='AdmRunToGoal__Settings__Controls__Inputs' type='number' min={0} value={timeoutMs} onChange={onTimeoutMs} />
                    <small className="AdmRunToGoal__Help">0 = Desactivado. Recomendado (si lo usas): 300–500 ms.</small>

                    {(phase === status.WAITING) && (
                        isWorking ? (
                            <button className='Btn__Adsl--Disabled AdmRunToGoal__Settings__Controls__Buttons AdmRunToGoal__SpaceUp'>Iniciando juego...</button>
                        ) : (
                            <button className='Btn__Adsl--RedOutlineTransparent AdmRunToGoal__Settings__Controls__Buttons AdmRunToGoal__SpaceUp' onClick={StartGame}>
                                <i className="bi bi-play-circle"></i> Iniciar juego
                            </button>
                        )
                    )}

                    {(phase === status.RUNNING || phase === status.FINISHED) && (
                        isWorking ? (
                            <button className='Btn__Adsl--Disabled AdmRunToGoal__Settings__Controls__Buttons AdmRunToGoal__SpaceUp'>Reiniciando juego...</button>
                        ) : (
                            <button className='Btn__Adsl--RedOutlineTransparent AdmRunToGoal__Settings__Controls__Buttons AdmRunToGoal__SpaceUp' onClick={ResetGame}>
                                <i className="bi bi-arrow-counterclockwise"></i> Reiniciar juego
                            </button>
                        )
                    )}
                    
                    {error && <p className='AdmRunToGoal__Settings__Controls__Error'>{error}</p>}
                </div>
            </section>
        </SecondaryBase>
    )
}

export { Balloons };